import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { SystemOverview } from './components/SystemOverview';
import { InsideCarousel } from './components/InsideCarousel';
import { Testimonials } from './components/Testimonials';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { WhyDifferent } from './components/WhyDifferent';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  loaded?: boolean;
  version?: string;
  push?: MetaPixel;
};
type MetaWindow = Window & {
  fbq?: MetaPixel;
  _fbq?: MetaPixel;
};
const META_PIXEL_ID = '1367632915547845';
export function App() {
  useEffect(() => {
    const w = window as MetaWindow;
    try {
      if (!w.fbq) {
        const pixel = ((...args: unknown[]) => {
          if (pixel.callMethod) {
            pixel.callMethod(...args);
          } else {
            pixel.queue.push(args);
          }
        }) as MetaPixel;
        pixel.queue = [];
        pixel.push = pixel;
        pixel.loaded = true;
        pixel.version = '2.0';
        w.fbq = pixel;
        w._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
        w.fbq('init', META_PIXEL_ID);
      }
      w.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init failed:', error);
    }
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-ink antialiased" data-id="element-0" data-mp="36huv2f1ajz4">
      <noscript data-id="element-1" data-mp="38kxqn1ac7l9">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1367632915547845&ev=PageView&noscript=1" alt="" data-id="element-2" data-mp="3uct43lu76r1j" />
      </noscript>
      <main data-id="element-3" data-mp="86mgf6usu4w7">
        <Hero data-id="element-4" data-mp="864atjm8yebm" />
        <InsideCarousel data-id="element-5" data-mp="86cqfj9r7xqi" />
        <Testimonials data-id="element-6" data-mp="3glea6jyr55fp" />
        <PainPoints data-id="element-7" data-mp="3gkla21uate6j" />
        <SolutionReveal data-id="element-8" data-mp="3gm665vw9h56i" />
        <SystemOverview data-id="element-9" data-mp="3gja5w0wxy4ew" />
        <TomosSection data-id="element-10" data-mp="3bmbalf1jjrf4" />
        <WhyDifferent data-id="element-11" data-mp="3bn2ye3owckuu" />
        <BonusSection data-id="element-12" data-mp="3bnmk7vho3te5" />
        <PricingSection data-id="element-13" data-mp="3bk70uggyny6x" />
        <Guarantee data-id="element-14" data-mp="3qaxrhl6tgr8g" />
        <FAQ data-id="element-15" data-mp="3qbfvx53mubrg" />
        <FinalCTA data-id="element-16" data-mp="3qc948ai8p9bp" />
      </main>
      <Footer data-id="element-17" data-mp="3qdaisoygsdy6" />
      <PurchaseNotifications data-id="element-18" data-mp="3qd0oip6dzkmo" />
    </div>;
}